import * as React from 'react'

import { nanoid } from 'nanoid'

import { DataFieldStyled } from './styles/DataFieldStyled'
import { type IFieldProps } from '@ui/blocks/Field'

export interface IDataFieldProps extends IFieldProps {
  id?: string
  label?: string
  layout?: IFieldProps['layout']
}

export const DataField = ({
  id,
  label,
  children,
  layout,
  ...fieldProps
}: React.PropsWithChildren<IDataFieldProps>) => {
  const fieldId = id || nanoid(10)

  return (
    <DataFieldStyled
      layout={layout}
      label={label}
      labelId={fieldId}
      {...fieldProps}
    >
      <div className='value-container' aria-labelledby={fieldId}>
        {children}
      </div>
    </DataFieldStyled>
  )
}
